<template>
  <div class="report" v-if="mySelf">
    <v-card flat>
      <v-progress-circular
        indeterminate
        :size="50"
        :width="7"
        color="secondary"
        v-if="loading_data"
      >
      </v-progress-circular>
      <v-row v-if="!loading_data">
        <v-col cols="auto" class="pa-7">
          <!-- -->
          <v-row>          
            <v-col>
              <v-text-field
                dense
                type="date"
                v-model="selected_date"
                v-on:click="calcReport = false"
                label="Datum"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-checkbox
                dense
                v-model="checkbox_month"
                v-on:click="calcReport = false"
                label="Only Set Month"
              ></v-checkbox>
            </v-col>  
            <v-col>
              <v-checkbox
                dense
                v-model="checkbox_project"
                v-on:click="calcReport = false"
                label="Filter Project"
              ></v-checkbox>
            </v-col>
            <v-col v-if="checkbox_project">
              <v-autocomplete
                dense
                :items="Issues"     
                item-text="name"
                item-value="_id"
                v-model="selected_project"
                v-on:click="calcReport = false"
                label="Project"
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-checkbox
                dense
                v-model="checkbox_location"
                v-on:click="calcReport = false"
                label="Filter Location"
              ></v-checkbox>
            </v-col>            
            <v-col v-if="checkbox_location">
              <v-autocomplete
                dense
                :items="Locations"     
                item-text="name"
                item-value="_id"
                v-model="selected_location"
                v-on:click="calcReport = false"
                label="Location"
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-checkbox
                dense
                v-model="checkbox_costcenter"
                v-on:click="calcReport = false"
                label="Filter Costcenter"
              ></v-checkbox>
            </v-col>            
            <v-col v-if="checkbox_costcenter">
              <v-autocomplete
                dense
                :items="Costcenters"     
                item-text="name"
                item-value="_id"
                v-model="selected_costcenter"
                v-on:click="calcReport = false"
                label="Costcenter"
              ></v-autocomplete>
            </v-col>
            <v-col v-if="mySelf.roles.includes('admin')">
              <v-checkbox
                dense
                v-model="checkbox_user"
                v-on:click="calcReport = false"
                label="Filter User"
              ></v-checkbox>
            </v-col>            
            <v-col v-if="checkbox_user">
              <v-autocomplete
                dense
                :items="Users"     
                item-text="fullname"
                item-value="_id"
                v-model="selected_user"
                v-on:click="calcReport = false"
                label="User"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="!calcReport">
              <v-btn color="blue" small dark @click="generateExcel()">
                Generate Detail Report
              </v-btn>
            </v-col>
            <v-col v-if="!calcReport">
              <v-btn color="blue" small dark @click="generateExcel2()">
                Generate Projekt Level Report
              </v-btn>
            </v-col>
          </v-row>
          <v-row>

            

            <v-col v-if="calcReport">
              <download-excel
                :data="json_data"
                :fields="json_fields"
                :header="json_title"
                worksheet="Report"
              >
                <v-btn color="success" small elevation="1"
                  >Download Excel</v-btn
                >
              </download-excel>
            </v-col>
            <v-col v-if="calcReport">
              <v-btn
                color="error"
                small
                elevation="1"
                v-on:click="calcReport = false"
                >Cancel</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mx-4 font-weight-bold">
          {{json_title}}
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mx-4">
          <v-data-table :headers="json_header" :items="json_data">
          </v-data-table>
        </v-col>
      </v-row>
   
    </v-card>
    <v-snackbar v-model="snackbar" color="error">
      {{ snackbar_text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="snackbar = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import _ from "lodash";

export default {
  name: "report",
  components: {},
  data() {
    return {
      snackbar: false,
      snackbar_text: "",
      loading_data: true,
      userOptions: {
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        chart: {
          id: "user",
        },
        xaxis: {
          categories: [],
        },
      },
      userSeries: [],
      userCountSeries: [],
      userDurationSeries: [],
      machineOptions: {
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        chart: {
          id: "machine",
        },
        xaxis: {
          categories: [],
        },
      },
      machineSeries: [],
      machineCountSeries: [],
      machineDurationSeries: [],
      machineUtilisationSeries: [],
      buyableOptions: {
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        chart: {
          id: "buyable",
        },
        xaxis: {
          categories: [],
        },
      },
      buyableSeries: [],
      buyableCountSeries: [],
      buyableDurationSeries: [],
      buyableUtilisationSeries: [],
      issuedCoinsOptions: {
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        chart: {
          id: "issuedCoins",
        },
        xaxis: {
          categories: ["Aktuell"],
        },
      },
      issuedCoinsSeries: [],
      machines: [],
      buyables: [],
      isCertificate: false,

      json_data: [],
      json_header: [],
      json_fields: {},
      json_title: "",
    
      calcReport: false,
      selected_date: this.$moment().format("YYYY-MM-DD"),
      selected_project: "",
      checkbox_project: false,
      checkbox_month: false,
      checkbox_user: false,
      selected_user: "",
      checkbox_costcenter: false,
      selected_costcenter: "",
      checkbox_location: false,
      selected_location: ""
    };
  },
  async mounted() {

    if (this.mySelf.roles.includes('admin')) {
      await this.getUsers({});
    }

   

    await this.getIssues();
    await this.getLocation({});
    await this.getCostcenters({active: true});

    this.loading_data = false;

  },
  computed: {
    ...mapState({
      loading: (state) => state.loading,
      statusMySelf: ({ auth }) => auth.statusMySelf,
      mySelf: ({ auth }) => auth.mySelf,
      Drawer: (state) => state.drawer,
      Event: (state) => state.event,

    }),
  },
  methods: {
    ...mapActions("event", ["getEventsReport"]),


   

    async loadReportEvents(filter) {
      await this.getEventsReport(filter);
      //console.log(this.Event.Events);
    },

    async generateExcel() {
      this.calcReport = false;
      this.json_data = [];
      
      this.json_title = "Detailed Report: " + this.$moment(this.selected_date, "YYYY-MM-DD").format("MMM YYYY");
      let filter = {};
      
      if (this.checkbox_month) {
        
        filter.from = this.$moment(this.selected_date, "YYYY-MM-DD")
          .startOf("month")
          .format("X");
        filter.to = this.$moment(this.selected_date, "YYYY-MM-DD")
          .endOf("month")
          .format("X");
      } else {
        this.json_title += " to " + this.$moment(new Date(), "YYYY-MM-DD").format("MMM YYYY");
        filter.from = this.$moment(this.selected_date, "YYYY-MM-DD").format("X");
      }

      const selected_project_name = _.find(this.Issues, {_id: this.selected_project});
      if (this.checkbox_project) {
        this.json_title += " of Project " + selected_project_name.name;
        filter.issue = this.selected_project;
      }

      const selected_user_name = _.find(this.Users, {_id: this.selected_user});
      if (this.checkbox_user) {
        this.json_title += " and User " + selected_user_name.fullname;
        filter.user_id = this.selected_user;

      }
      const selected_location_name = _.find(this.Locations, {_id: this.selected_location});
      if (this.checkbox_location) {
        this.json_title += " and Location " + selected_location_name.name;
        filter.location = this.selected_location;
      }

      const selected_costcenter_name = _.find(this.Costcenters, {_id: this.selected_costcenter});
      if (this.checkbox_costcenter) {
        this.json_title += " and Costcenter " + selected_costcenter_name.name;
        filter.costcenter = this.selected_costcenter;
      }

      await this.loadReportEvents(filter);

  

      let filteredEvents = _.orderBy(this.Event.Events.events, [
        "user_id.fullname",
        "start",
      ]);

   

      for (let event of filteredEvents) {
      

        let obj = {};
        obj.location = event.location.name;
        obj.User = event.user_id.fullname;

        let maxIssue;
        for (maxIssue = 1; maxIssue <= 5; maxIssue++) {
          
          let n2 = "issue" + String(maxIssue);
          //console.log("maxIssue: ", maxIssue, n2, event[n2]);
          if (!event[n2]) {
            maxIssue--;
            break;
          } else if (event[n2].name.length == 0) {
            maxIssue--;
            break;
          } 
          
        }
        //console.log(maxIssue);

        for (let i = maxIssue; i > 0; i--) {
          let n = "issue" + String(maxIssue - i + 1);
          let n2 = "issue" + String(i);
          if (event[n2]) {
            obj[n] = event[n2].name;
          }
        }

        //console.log(event)
        if (event.costcenter) {
          if (event.costcenter.name) {
            obj.Costcenter = event.costcenter.name;
          } else {
            event.costcenter.name = "not found";
          }
        }
        obj.Description = event.name;
        if (obj.Description.lastIndexOf("|") > 0) {
          obj.Description = obj.Description.substring(
            obj.Description.lastIndexOf("|") + 2,
            obj.Description.length
          );
        }
        obj.StartDate = this.$moment(event.start).format("DD.MM.YYYY");
        obj.StartTime = this.$moment(event.start).format("HH:mm");
        obj.EndDate = this.$moment(event.end).format("DD.MM.YYYY");
        obj.EndTime = this.$moment(event.end).format("HH:mm");
        obj.Hours =
          (this.$moment(event.end) - this.$moment(event.start)) / 3600 / 1000;
        obj.Hours = String(obj.Hours).replace(".", ",");

      
        report.push(obj);
      }
      this.generateHeader(report);
      this.json_data = _.orderBy(report, ["start"], ["desc"]);
      for (let data of this.json_data) {
        data.Hours = String(data.Hours).replace(",", ".");
        data.Hours = parseFloat(data.Hours);
      }
      //console.table(this.json_data);
      this.json_title += "   -- Gesamt Stunden: " + _.sumBy(this.json_data, "Hours");
      //console.log(this.json_data)
      this.calcReport = true;
    },

    async generateExcel2() {
      this.json_data = [];
      this.json_title = "Projekt Level Report: " + this.$moment(this.selected_date, "YYYY-MM-DD").format("MMM YYYY");
      this.calcReport = false;
      let filter = {};
    
      if (this.checkbox_month) {
        filter.from = this.$moment(this.selected_date, "YYYY-MM-DD")
          .startOf("month")
          .format("X");
        filter.to = this.$moment(this.selected_date, "YYYY-MM-DD")
          .endOf("month")
          .format("X");
      } else {
        this.json_title += " to " + this.$moment(new Date(), "YYYY-MM-DD").format("MMM YYYY");
        filter.from = this.$moment(this.selected_date, "YYYY-MM-DD").format("X");
      }

      const selected_project_name = _.find(this.Issues, {_id: this.selected_project});
      if (this.checkbox_project) {
        this.json_title += " of Project " + selected_project_name.name;
        filter.issue = this.selected_project;
      }

      const selected_user_name = _.find(this.Users, {_id: this.selected_user});
      if (this.checkbox_user) {
        this.json_title += " and User " + selected_user_name.fullname;
        filter.user_id = this.selected_user;
      }

      const selected_location_name = _.find(this.Locations, {_id: this.selected_location});
      if (this.checkbox_location) {
        this.json_title += " and Location " + selected_location_name.name;
        filter.location = this.selected_location;
      }

      const selected_costcenter_name = _.find(this.Costcenters, {_id: this.selected_costcenter});
      if (this.checkbox_costcenter) {
        this.json_title += " and Costcenter " + selected_costcenter_name.name;
        filter.costcenter = this.selected_costcenter;
      }

      await this.loadReportEvents(filter);

      this.generateHeader(this.Event.Events.results3);
      this.json_data = this.Event.Events.results3;


      this.json_data = _.orderBy(this.json_data, [
        "fullname",
        "issue",
        "productive",
      ]);
      for (let data of this.json_data) {
         data.duration = parseFloat(data.duration);
      }
      //console.table(this.json_data);
      this.json_title += "   -- Gesamt Stunden: " + _.sumBy(this.json_data, "duration");
      this.calcReport = true;
    },


  
    async generateHeader(items) {
      let arr = [];
      this.json_fields = {};
      if (items.length > 0) {
        let foundIdx = 0;
        let itemLength = 0;
        for (let idx in items) {
          //console.log("Issue ", idx, items[idx] ,Object.keys(items[idx]).length)
          if (itemLength < Object.keys(items[idx]).length) {
            itemLength = Object.keys(items[idx]).length;
            foundIdx = idx;
          }
        }
        //console.log("Longest Issue ", items[foundIdx], foundIdx)
        for (let item of Object.keys(items[foundIdx])) {
          let obj = {};
          obj.text = this.$t(String(item));
          obj.value = item;
          this.json_fields[this.$t(String(item))] = item;
          arr.push(obj);
        }
        this.json_header = arr;
        //console.log(this.json_header)
      }
    },

  
  },
  watch: {},
};
</script>

<style>
.box-grey {
  border: solid 1px lightgrey;
}
</style>